/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import Loader from 'react-loader-spinner'
import { getCategoryRequest } from '../../../redux-saga/User/AllCategory/Reducer'
import CategoryCard from '../../../components/Mobile/CategoryCard'
import CarouselComponent from '../../../components/Mobile/Carousel'
import './index.scss'
import ImageCarouselComponent from '../../../components/Mobile/ImageCarouselComponent'
import SpinLoader from '../../../components/Mobile/Loader'
import { ROUTE } from '../../../utils/User/constants/routingConfig/routeDetails'

const Home = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { categories, fetching } = useSelector((state) => state.categories)
  useEffect(() => {
    if (categories?.length === 0) {
      dispatch(getCategoryRequest())
    }
  }, [])
  const handleCategory = (id) => {
    history.push(`${ ROUTE.PESTICIDESBY }/${ id }`)
  }
  return (
    <div className='mid-container'>
      <div id='jum-1' className='jumbotron jumbotron-fade'>
        {/* <div className='row'>
          <div className='col-md-11 '>
            <div className='input-group'>
              <div className='input-group-prepend'>
                <span
                  className='input-group-text btn btn-lg'
                >
                  <i className='fa fa-search fa-lg' aria-hidden='true' />
                </span>
              </div>
              <input className='form-control' placeholder='Search your desire.....' name='search' type='search' />
              <button type='button' className='input-group-text btn btn-lg'>Search</button>
            </div>
          </div>
        </div>
        <div className='row mt-3'>
          <div className='col-md-12 text-center'><p id='p1'>New !</p></div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <p id='p2' className='display-4 font-weight-bold text-center'>C O L L E C T I O N - 2 0 2 1 !</p>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <p id='p3' className='text-center'>-------for-------</p>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <p id='p2' className='display-4 font-weight-bold text-center'>R A B I   !!&!!  K H A R I F </p>
          </div>
        </div> */}

      </div>
      {/* <ImageCarouselComponent
        itemsPerSlide={ 1 }
      >
        <div className='carousel-container'><CategoryCard /></div>
      </ImageCarouselComponent> */}
      {
        fetching && (
          <SpinLoader />
        )
      }
      <div className='container-fluid category'>
        <CarouselComponent>
          {
               categories?.length > 0 && (
                 categories.map((cate) => (
                   <Link className='font-weight-bold' key={ cate.id } onClick={ () => handleCategory(cate.id) }>
                     { cate.name }
                   </Link>
                 ))
               )
             }
        </CarouselComponent>
      </div>
      <div className='container-fluid'>
        <div className='container'>
          <div className='row'>
            <CategoryCard />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
